export const common = {
  nav: {
    home: "Nyumbani",
    about: "Kuhusu Sisi",
    projects: "Miradi",
    news: "Habari",
    getInvolved: "Jiunge Nasi",
    donateNow: "Toa Mchango"
  },
  footer: {
    about: {
      description: "Kuwezesha wakimbizi na jamii zilizo hatarini nchini Jamhuri ya Kidemokrasia ya Kongo kupitia msaada wa dharura, huduma za afya, elimu, na maendeleo endelevu."
    },
    newsletter: {
      placeholder: "Weka barua pepe yako"
    },
    quickLinks: {
      title: "Viungo vya Haraka",
      home: "Nyumbani",
      about: "Kuhusu Sisi",
      projects: "Miradi",
      news: "Habari",
      getInvolved: "Jiunge Nasi",
      contact: "Wasiliana Nasi"
    },
    social: {
      title: "Unganisha Nasi"
    },
    copyright: "© 2024 BridgeCore empowermennt initiative. Haki zote zimehifadhiwa."
  },
  buttons: {
    donate: "Toa Mchango",
    volunteer: "Kuwa Mtoaji Msaada",
    learnMore: "Jifunze Zaidi",
    readMore: "Soma Zaidi",
    viewAll: "Tazama Zote"
  }
};
